export default __webpack_public_path__ + "static/media/Ms. Mukulika Panda.a0fcfd6e.png";